import { render, staticRenderFns } from "./MyTemplateReports.vue?vue&type=template&id=0be6c024&scoped=true&"
import script from "./MyTemplateReports.vue?vue&type=script&lang=js&"
export * from "./MyTemplateReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be6c024",
  null
  
)

export default component.exports